<h1 mat-dialog-title>Item Details</h1>
<div mat-dialog-content>
  <!-- İlgili satır bilgilerini gösteren HTML kodu -->
  <table class="table table-bordered" *ngIf="item">
    <thead>
      <tr>
        <th>Content</th>
        <th>Description</th>
        <th>Price</th>
        <th>Quantity</th>
        <th>QuantityUnit</th>
        <th>Tax</th>
        <th>TotalPrice</th>         
    </tr>
    </thead>
    <tbody>
      <tr>
        <td><input type="text" class="form-control" id="Content" [value]="item.content.value"></td>
        <td><input type="text" class="form-control" id="Description" [value]="item.description.value"></td>
        <td><input type="text" class="form-control" id="Price" [value]="item.price.value"></td>
        <td><input type="text" class="form-control" id="Quantity" [value]="item.quantity.value"></td>
        <td><input type="text" class="form-control" id="QuantityUnit" [value]="item.quantityUnit.value"></td>
        <td><input type="text" class="form-control" id="Tax" [value]="item.tax.value"></td>
        <td><input type="text" class="form-control" id="TotalPrice" [value]="item.totalPrice.value"></td>      
    </tr>
    </tbody>
  </table>
</div>
<div mat-dialog-actions>
  <button type="button" class="btn btn btn-success btn-sm" (click)="onClose()">Close</button>
</div>